import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION1: PdfComponent = {
  type: 'section',
  id: 's3s1',
  title: '1. Purpose and Scope',
  content: [
    {
      type: 'altText',
      id: 's1s1heading',
      content: [
        'This Procedure Guide applies to the handling of credit applications and fulfilment under this Agreement. It must be read in the context of the Permitted Sales Channels applicable to specific Retailers. The obligations below apply to Kanda and Retailers using credit facilities introduced or administered by Kanda.',
      ],
      boldFirst: false,
    },
  ],
};
